<template>
  <template-layout :is-hide-menu="true">
    <div>
      <div class="main-banner">
        <TinySlider
          :options="{
            mode: 'gallery',
            nav: true,
            speed: 500,
          }"
        >
          <!-- <div class="main-image-slide">-->
          <div>
            <img src="@/assets/images/main/banner-msologbook-V2.2.jpg" />
          </div>
        </TinySlider>
      </div>
      <div class="relative mt-6">
        <div class="w-full px-7 pt-5 bg-theme-39 rounded-2xl mb-5 pb-0">
          <div class="absolute px-4 py-3 rounded-tl-2xl rounded-br-2xl bg-blue-custom" style="top: 0; left: 0">
            <p class="text-white" style="letter-spacing: .5px">เงื่อนไขการแสดงผล</p>
          </div>
          <br />
          <div class="grid grid-cols-12">
            <div
              class="col-span-full xl:col-span-6 text-sm font-medium text-center light:text-gray-400 light:border-gray-700">
              <div class="flex flex-wrap -mb-px" style="margin-top: 1rem; margin-bottom: 0px;">
                <div class="w-full sm:w-auto mr-2 text-left">
                  <p class="text-blue-custom">
                    การแสดงข้อมูล &nbsp;:&nbsp;
                  </p>
                </div>
                <div class="mr-2 w-full sm:w-auto text-left">
                  <p @click="changeDisplayData(0)"
                    class="cursor-pointer inline-block px-2 pb-2 sm:pb-4 my-1 sm:my-0 rounded-t-lg border-b-4"
                    :class="{ 'nav-active': $store.state.main.displayData == 0, 'text-grey-custom': $store.state.main.displayData != 0 }">
                    ทั้งประเทศ
                  </p>
                </div>
                <div class="mr-2 w-full sm:w-auto text-left">
                  <p @click="changeDisplayData(1)"
                    class="cursor-pointer inline-block px-2 pb-2 sm:pb-4 my-1 sm:my-0 rounded-t-lg border-b-4"
                    :class="{ 'nav-active': $store.state.main.displayData == 1, 'text-grey-custom': $store.state.main.displayData != 1 }">
                    รายพื้นที่
                  </p>
                </div>
                <div class="mr-2 w-full sm:w-auto text-left">
                  <p @click="changeDisplayData(2)"
                    class="cursor-pointer inline-block px-2 pb-2 sm:pb-4 my-1 sm:my-0 rounded-t-lg border-b-4"
                    :class="{ 'text-grey-custom': $store.state.main.displayData != 2, 'nav-active': $store.state.main.displayData == 2 }">
                    สำนักงานส่งเสริมและสนับสนุนวิชาการ
                  </p>
                </div>
              </div>
            </div>

            <div
              class="relative col-span-full w-full float-left sm:float-right xl:col-span-6 xl:col-end-auto mb-3 mt-3 sm:mt-0">
              <div class="sm:flex float-left sm:float-right">
                <div class="text-left sm:text-right">
                  <p class="w-72 float-left sm:float-right">
                    <small class="text-grey-custom">ระดับของข้อมูล</small>
                  </p>
                  <div style="clear: both"></div>

                  <div class="text-left sm:text-right text-base text-blue-custom font-bold my-1 mt-2 h-4"
                    v-if="searchResultText && $store.state.main.displayData != 0" @click="handleSelectedChange"
                    style="cursor: pointer; line-height: .8">
                    <span class="truncate" v-html="searchResultText" style="width: 200px"></span> &nbsp;
                    <font-awesome-icon :icon="['fas', 'caret-down']" class="text-pink-custom" />
                  </div>
                  <p class="text-left sm:text-right text-base text-blue-custom font-bold my-1 mt-2"
                    v-else-if="searchResultText == '' && $store.state.main.displayData != 0"
                    @click="handleSelectedChange" style="cursor: pointer">ทั้งประเทศ &nbsp;
                    <font-awesome-icon :icon="['fas', 'caret-down']" class="text-pink-custom" />
                  </p>
                  <p class="text-left sm:text-right text-base text-blue-custom font-bold mt-1" v-else>ทั้งประเทศ &nbsp;
                  </p>
                  <searchDropdown v-model="$store.state.mainFilterSearch.showDropdownSearch" class="rounded-md absolute"
                    :valueSelected="valueSelected" @click:cancel="handleClickCancel" @click:save="handleSearch">
                  </searchDropdown>
                </div>
                <button @click="filterBtnClick" class="rounded-md bg-blue-custom p-1 h-7 sm:ml-3 mt-2 sm:mt-auto">
                  <FilterIcon class="text-white" size="20" />
                  <font-awesome-icon
                    v-if="$store.state.main.fragilePicked.length || $store.state.main.probPicked.length"
                    :icon="['fas', 'circle']"
                    style="position: absolute;right: -5px; bottom:1.3rem; color: #fb6f70; font-size: .8rem" />
                </button>
                <filterDropdown :filterBtnState="filterBtnState" :fragilePicked="fragilePicked"
                  :probPicked="probPicked" />
              </div>

            </div>
          </div>
          <!-- <FilterSummaryItem v-for="item in items" :key="item.titel" :title="item.title" :text="item.text" /> -->
        </div>

        <!-- จำนวนคนตามกลุ่มเป้าหมาย Section -->
        <div class="relative mt-5">

          <div class="grid grid-cols-12">
            <h3 class="col-span-12 md:col-span-6 text-xl font-bold leading-none mt-3 text-custom-member">
              จำนวนคนตามกลุ่มเป้าหมาย
            </h3>
            <div class="relative sm:absolute right-0 col-span-12 md:col-span-6 mt-3 md:mt-0">
              <div class="grid grid-cols-2">
                <h3 class="col-end-auto text-md text-right mt-2 font-bold w-auto text-light-blue-custom">
                  กลุ่มเป้าหมาย &nbsp;: &nbsp;&nbsp;
                </h3>
                <div class="col-auto flex rounded-lg border border-gray-300 overflow-hidden">
                  <fieldset class="flex-grow text-center">
                    <input class="peer" type="radio" name="target_group" id="ageRangeId" value="1"
                      v-model="selectTargetGroupState">
                    <label
                      class="inline-block text-md w-full py-2 px-2 cursor-pointer text-theme-37 hover:bg-gray-100 peer-checked:bg-theme-2 peer-checked:text-white select-none"
                      for="ageRangeId">ตามช่วงวัย</label>
                  </fieldset>
                  <fieldset class="flex-grow text-center border-l border-gray-300">
                    <input class="peer" type="radio" name="target_group" id="issuedBasedId" value="2"
                      v-model="selectTargetGroupState">
                    <label
                      class="inline-block text-md w-full py-2 px-2 cursor-pointer text-theme-37 hover:bg-gray-100 peer-checked:bg-theme-2 peer-checked:text-white select-none"
                      for="issuedBasedId">เชิงประเด็น</label>
                  </fieldset>
                </div>
              </div>
            </div>
          </div>

          <div id="target_group_section" class="relative">
            <div class="flex space-x-6 mt-4 overflow-x-auto overflow-y-hidden" v-if="this.TargetGroupState">
              <div class="report-box-2 mt-2 target-group-box" :class="[i.shadow]" style=" padding-bottom: .5rem"
                v-for="(i, k) in boxCardActiveArray" :key="k">
                <div class="box sm:flex h-full" :class="[i.bg, i.color]">

                  <div class="px-4 py-4 flex flex-col justify-center flex-1">
                    <div class="flex items-center justify-between">
                      <span class="text-lg font-semibold sm:text-lg">{{ i.text }}</span>
                      <span class="
                      w-10
                      h-10
                      px-1
                      py-1
                      flex
                      items-center
                      justify-center
                      rounded-full
                      bg-white
                      text-theme-17
                      ml-2
                      box-shadow
                    ">
                        <img :src="require('@/assets/images/icon/main/' + folderIcon + '/' + i.icon + '.png')"
                          alt="not found" style="padding: 3px" :title="i.icon" />
                      </span>
                    </div>
                    <div>
                      <div>
                        <div v-if="i.count >= 1000000"
                          class="relative text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold ml-0.5">
                          {{ this.millionShortNum(i.count) }} {{ this.millionShortString(i.count) }}คน
                        </div>
                        <div v-else class="relative text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold ml-0.5">
                          {{ this.globalNumDecFixed(i.count, 0) }} คน
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="relative w-full h-full" style="min-height: 100px"
              v-if="!this.TargetGroupState && !this.TargetGroupError">
              <div class="absolute w-20 h-20 left-0 right-0 top-0 bottom-0 m-auto">
                <LoadingIcon icon="three-dots" class="loading-icon" />
              </div>
            </div>

            <div class="relative w-full h-full" style="min-height: 100px" v-if="this.TargetGroupError">
              <div class="absolute w-44 h-20 left-0 right-0 bottom-0 pt-7 m-auto">
                <p class="text-grey2-custom text-center">ไม่สามารถเชื่อมข้อมูลได้</p>
              </div>
            </div>

            <!-- btn left-right -->
            <div id="arrow-left-target-group" class="absolute" style="top: 4.5rem; left: -10px;">
              <font-awesome-icon :icon="['fas', 'circle']" style="color: #fff;" class="drop-shadow-lg text-2xl" />
              <font-awesome-icon :icon="['fas', 'chevron-left']" style="color: #8a9dca; top: 6px; left: 7px;"
                class="absolute drop-shadow-lg text-md" />
            </div>
            <div id="arrow-right-target-group" class="absolute" style="top: 4.7rem; right: -10px;">
              <font-awesome-icon :icon="['fas', 'circle']" style="color: #fff; " class="drop-shadow-lg text-2xl" />
              <font-awesome-icon :icon="['fas', 'chevron-right']" style="color: #8a9dca; top: 6px; right: 7px;"
                class="absolute drop-shadow-lg text-md" />
            </div>
          </div>
        </div>

        <Statistics />
        <NewsSection />
        <AnnouncementsModal />
      </div>
    </div>
  </template-layout>
</template>

<script>

import TemplateLayout from "@/layouts/side-menu/Main.vue";
import Statistics from "./container/Statistics.vue";
import NewsSection from "./container/NewsSection.vue";
import AnnouncementsModal from "@/components/modal-announcements/index.vue";
import fragileSummaryImport from '../../assets/json/main/1_fragile_summary.json'
import { computed, defineComponent, reactive, ref, watch, getCurrentInstance } from "vue";
import searchDropdown from './container/searchDropdownMain.vue'
import filterDropdown from './container/filterDropdown.vue'

import $ from "jquery";
import axios from "axios"

import { useStore } from "@/store";
const store = useStore();
const headers = {
    "Content-Type": `application/json; charset=utf-8`,
    "Cache-Control": 'max-age=3600'
};
export default defineComponent({
  components: {
    TemplateLayout,
    Statistics,
    NewsSection,
    AnnouncementsModal,
    searchDropdown,
    filterDropdown
  },
  setup() {
    const TargetGroupKey = ref(1);
    const selectTargetGroupState = ref(1);
    const folderIcon = ref("age_range");
    const boxCardActiveArray = ref([]);
    const filterBtnState = ref(false);
    const fragilePicked = ref();
    fragilePicked.value = store.state.main.fragilePicked;
    const probPicked = ref();
    probPicked.value = store.state.main.probPicked;
    const TargetGroupState = ref(false);
    const TargetGroupError = ref(false);

    const fragileSummaryMock = ref({
      age_range: {
        youngchild: 0,
        child: 0,
        adolescence: 0,
        adult: 0,
        elderly: 0
      },
      issue_based: {
        disabled: 0,
        hiv_affected: 0,
        homeless: 0,
        beggar: 0,
        helpless: 0,
        adolescent_pregnancy: 0,
        family_violence: 0,
        human_trafficking: 0,
        single_parents: 0
      }
    })
    const boxCardAgeRange = reactive([
      {
        text: "เด็กเล็ก",
        bg: "bg-custom-card-1",
        count: fragileSummaryMock.value.age_range.youngchild,
        shadow: "before:bg-custom-hshadow",
        color: "text-custom-member",
        icon: "youngchild",
      }, {
        text: "เด็ก",
        bg: "bg-custom-card-2",
        count: fragileSummaryMock.value.age_range.child,
        shadow: "before:bg-custom-hshadow",
        color: "text-custom-member",
        icon: "child",
      },
      {
        text: "เยาวชน",
        bg: "bg-custom-card-3",
        count: fragileSummaryMock.value.age_range.adolescence,
        shadow: "before:bg-custom-fshadow",
        color: "text-custom-member",
        icon: "adolescence",
      },
      {
        text: "วัยผู้ใหญ่",
        bg: "bg-custom-card-4",
        count: fragileSummaryMock.value.age_range.adult,
        shadow: "before:bg-custom-fshadow",
        color: "text-white",
        icon: "adult",
      },
      {
        text: "ผู้สูงอายุ",
        bg: "bg-custom-card-5",
        count: fragileSummaryMock.value.age_range.elderly,
        shadow: "before:bg-custom-mshadow",
        color: "text-white",
        icon: "elderly",
      },
    ]);
    const boxCardIssueBased = reactive([
      {
        text: "คนพิการ",
        bg: "bg-custom-card-1",
        count: fragileSummaryMock.value.issue_based.disabled,
        shadow: "before:bg-custom-hshadow",
        color: "text-custom-member",
        icon: "disabled",
      },
      {
        text: "ขอทาน",
        bg: "bg-custom-card-2",
        count: fragileSummaryMock.value.issue_based.beggar,
        shadow: "before:bg-custom-hshadow",
        color: "text-custom-member",
        icon: "beggar",
      },
      {
        text: "คนไร้ที่พึ่ง",
        bg: "bg-custom-card-3",
        count: fragileSummaryMock.value.issue_based.helpless,
        shadow: "before:bg-custom-fshadow",
        color: "text-custom-member",
        icon: "helpless",
      },
      {
        text: "ตั้งครรภ์ในวัยรุ่น",
        bg: "bg-custom-card-4",
        count: fragileSummaryMock.value.issue_based.adolescent_pregnancy,
        shadow: "before:bg-custom-fshadow",
        color: "text-white",
        icon: "adolescent_pregnancy",
      },
      {
        text: "ความรุนแรงในครอบครัว",
        bg: "bg-custom-card-5",
        count: fragileSummaryMock.value.issue_based.family_violence,
        shadow: "before:bg-custom-mshadow",
        color: "text-white",
        icon: "family_violence",
      },
      {
        text: "ผู้เสียหายจากการค้ามนุษย์",
        bg: "bg-custom-card-4",
        count: fragileSummaryMock.value.issue_based.human_trafficking,
        shadow: "before:bg-custom-fshadow",
        color: "text-white",
        icon: "human_trafficking",
      },
      {
        text: "พ่อแม่เลี้ยงเดี่ยว",
        bg: "bg-custom-card-3",
        count: fragileSummaryMock.value.issue_based.single_parents,
        shadow: "before:bg-custom-fshadow",
        color: "text-custom-member",
        icon: "single_parents",
      },
    ]);
    const selectState = ref('firstOptionValue')
    const valueSelected = ref('จังหวัด')
    const options = reactive(['ทั้งประเทศ', 'สำนักงานส่งเสริมและสนับสนุนวิชาการ', 'จังหวัด'])
    const showModal = ref(false)
    const searchResult = ref(null)
    const searchResultText = ref(null)
    const handleModal = (val) => {//when select change show modal
      if (val == "สำนักงานส่งเสริมและสนับสนุนวิชาการ" || val == "จังหวัด") {
        showModal.value = !showModal.value;
      }
    }
    const handleSelectedChange = () => {
      store.commit("mainFilterSearch/setShowDropdownSearch", !store.state.mainFilterSearch.showDropdownSearch);
      if (store.state.mainFilterSearch.showDropdownSearch == false && store.state.main.displayData == 0) {
        valueSelected.value = "ทั้งประเทศ";
        store.commit("mainFilterSearch/setSearchIsOpen", false);
      } else if (store.state.mainFilterSearch.showDropdownSearch == true && store.state.main.displayData == 1) {
        valueSelected.value = "จังหวัด";
        store.commit("mainFilterSearch/setSearchIsOpen", true);
      } else if (store.state.mainFilterSearch.showDropdownSearch == true && store.state.main.displayData == 2) {
        valueSelected.value = "สำนักงานส่งเสริมและสนับสนุนวิชาการ";
        store.commit("mainFilterSearch/setSearchIsOpen", true);
      }
    }
    const changeDisplayData = (num) => {
      store.commit("main/setDisplayData", num);
      if (num == 0) {
        valueSelected.value = "ทั้งประเทศ";
        searchResultText.value = "ทั้งประเทศ";
        store.commit('mainFilterSearch/setProvID', 0);
        store.commit('mainFilterSearch/setAmpID', 0);
        store.commit('mainFilterSearch/setTambolID', 0);
        store.commit('mainFilterSearch/setOSM', 0);
      }
      else if (num == 1 && searchResultText.value == null) {
        searchResultText.value = "ทั้งประเทศ";
      } else if (num == 2 && searchResultText.value == null) {
        searchResultText.value = "ทั้งประเทศ";
      }
    }
    const handleClickCancel = () => {
      valueSelected.value = "จังหวัด"
    }
    const handleOpenDropdown = () => {
      showDropdownSearch.value = false
    }
    const handleSearch = (val) => {
      let text = ""
      if (valueSelected.value == "จังหวัด" && val) {
        if (val.province) {
          text += "จังหวัด" + val.province.province_name
          if (val.district) {
            text += " <span class='text-pink-custom'>&nbsp;&nbsp;|&nbsp;&nbsp;</span><div class='block md:hidden'><br/></div> อำเภอ" + val.district.amphur_name
          }
          if (val.subdistrict) {
            text += " <span class='text-pink-custom'>&nbsp;&nbsp;|&nbsp;&nbsp;</span><div class='block md:hidden'><br/></div> ตำบล" + val.subdistrict.tumbol_name
          }
        }
        searchResultText.value = text
      }
      else {
        if (val.organize) {
          searchResultText.value = val.organize
        }
      }
    }

    return {
      TargetGroupState,
      fragileSummaryMock,
      boxCardAgeRange,
      boxCardIssueBased,
      selectState,
      options,
      valueSelected,
      handleModal,
      showModal,
      handleClickCancel,
      handleSearch,
      searchResult,
      searchResultText,
      handleSelectedChange,
      handleOpenDropdown,
      changeDisplayData,
      TargetGroupKey,
      selectTargetGroupState,
      folderIcon,
      boxCardActiveArray,
      filterBtnState,
      fragilePicked,
      probPicked
    }
  },
  mounted() {
    this.initialCardGroup();

    this.boxCardActiveArray = this.boxCardAgeRange;

    if ($('#target_group_section div').scrollLeft() <= 50) {
      $("#arrow-left-target-group").css("display", "none").fadeOut("slow");
    } else {
      $("#arrow-left-target-group").css("display", "block").fadeIn("slow");
    }
    var elem = $('#target_group_section div');
    $("#target_group_section div").scroll(function () {
      if ($('#target_group_section div').scrollLeft() <= 50) {
        $("#arrow-left-target-group").css("display", "none").fadeOut("slow");
      } else {
        $("#arrow-left-target-group").css("display", "block").fadeIn("slow");
      }
      if (elem[0].scrollWidth - elem.scrollLeft() <= elem.outerWidth() + 50) {
        $("#arrow-right-target-group").css("display", "none").fadeOut("slow");
      } else {
        $("#arrow-right-target-group").css("display", "block").fadeIn("slow");
      }
    });
  },
  methods: {
    globalNumDecFixed(num, dec_amount) {
      var new_num = Number(num);
      if (!(num % 1)) {
        dec_amount = 0;
      }
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: dec_amount,
      }).format(new_num.toFixed(dec_amount));
    },
    millionShortNum(num) {
      if (num >= 1000000000000000000000000) {
        return this.globalNumDecFixed(
          (num / 1000000000000000000000000).toFixed(2).replace(/\.0$/, ""),
          2
        );
      }
      if (num >= 1000000000000000000) {
        return this.globalNumDecFixed(
          (num / 1000000000000000000).toFixed(2).replace(/\.0$/, ""),
          2
        );
      }
      if (num >= 1000000000000) {
        return this.globalNumDecFixed((num / 1000000000000)
          .toFixed(2)
          .replace(/\.0$/, ""), 2);
      }
      if (num >= 1000000) {
        return this.globalNumDecFixed((num / 1000000)
          .toFixed(2)
          .replace(/\.0$/, ""), 2);
      }
      return this.globalNumDecFixed(num.toFixed(2).replace(/\.0$/, ""), 2);
    },

    millionShortString(num) {
      if (num >= 1000000000000000000000000) {
        return "ล้านล้านล้านล้าน";
      }
      if (num >= 1000000000000000000) {
        return "ล้านล้านล้าน";
      }
      if (num >= 1000000000000) {
        return "ล้านล้าน";
      }
      if (num >= 1000000) {
        return "ล้าน";
      }
      return '';
    },
    filterBtnClick() {
      this.filterBtnState = !this.filterBtnState;
    },
    getParams() {
      var params = {};
      if (store.state.mainFilterSearch.provID && store.state.mainFilterSearch.provID != 0) {
        params.prov = (store.state.mainFilterSearch.provID).toString();
      }
      if (store.state.mainFilterSearch.ampID && store.state.mainFilterSearch.ampID != 0) {
        params.amp = (store.state.mainFilterSearch.ampID).toString();
      }
      if (store.state.mainFilterSearch.tambolID && store.state.mainFilterSearch.tambolID != 0) {
        params.tam = (store.state.mainFilterSearch.tambolID).toString();
      }
      if (store.state.mainFilterSearch.osm && store.state.mainFilterSearch.osm != 0) {
        params.osm = (store.state.mainFilterSearch.osm).toString();
      }
      var fragilePickedArray = [...store.state.main.fragilePicked];
      var probPickedArray = [...store.state.main.probPicked];
      if (fragilePickedArray.includes('0')) {
        params.fg0 = 1;
      }
      if (fragilePickedArray.includes('1')) {
        params.fg1 = 1;
      }
      if (fragilePickedArray.includes('2')) {
        params.fg2 = 1;
      }
      if (fragilePickedArray.includes('3')) {
        params.fg3 = 1;
      }
      if (probPickedArray.includes('0')) {
        params.prob_housing = 1;
      }
      if (probPickedArray.includes('1')) {
        params.prob_health = 1;
      }
      if (probPickedArray.includes('2')) {
        params.prob_education = 1;
      }
      if (probPickedArray.includes('3')) {
        params.prob_occupation = 1;
      }
      if (probPickedArray.includes('4')) {
        params.prob_family = 1;
      }
      if (probPickedArray.includes('5')) {
        params.prob_violence = 1;
      }
      if (probPickedArray.includes('6')) {
        params.prob_human_trafficking = 1;
      }
      if (probPickedArray.includes('7')) {
        params.prob_accessibility = 1;
      }
      if (probPickedArray.includes('8')) {
        params.prob_others = 1;
      }

      return params;
    },
    async initialCardGroup() {
      this.TargetGroupState = false;
      this.TargetGroupError = false;
      var params = this.getParams();
      await axios.post(`${process.env.VUE_APP_BASE_API}member/getTargetGroupStats`,
        params,
        {headers}
      ).then((response) => {
        if (response.status === 200) {
          var data = response.data;
          this.fragileSummaryMock = data;
          this.TargetGroupKey++;
          this.TargetGroupState = true;
          this.boxCardAgeRange[0].count = this.fragileSummaryMock.age_range.youngchild
          this.boxCardAgeRange[1].count = this.fragileSummaryMock.age_range.child
          this.boxCardAgeRange[2].count = this.fragileSummaryMock.age_range.adolescence
          this.boxCardAgeRange[3].count = this.fragileSummaryMock.age_range.adult
          this.boxCardAgeRange[4].count = this.fragileSummaryMock.age_range.elderly
          this.boxCardIssueBased[0].count = this.fragileSummaryMock.issue_based.disabled
          this.boxCardIssueBased[1].count = this.fragileSummaryMock.issue_based.beggar
          this.boxCardIssueBased[2].count = this.fragileSummaryMock.issue_based.helpless
          this.boxCardIssueBased[3].count = this.fragileSummaryMock.issue_based.adolescent_pregnancy
          this.boxCardIssueBased[4].count = this.fragileSummaryMock.issue_based.family_violence
          this.boxCardIssueBased[5].count = this.fragileSummaryMock.issue_based.human_trafficking
          this.boxCardIssueBased[6].count = this.fragileSummaryMock.issue_based.single_parents
        } else {
          this.TargetGroupError = true;
          console.log(response.status.statusText);
        }
      }).catch((error) => {
        var message = error.response.data.message;
        this.TargetGroupError = true;
        console.log(message);
      });
    },
  },
  watch: {
    selectTargetGroupState(newValue) {
      if (newValue == 1) {
        this.boxCardActiveArray = this.boxCardAgeRange;
        this.folderIcon = 'age_range';
        this.TargetGroupKey++;
      } else {
        this.boxCardActiveArray = this.boxCardIssueBased;
        this.folderIcon = 'issue_based';
        this.TargetGroupKey++;
      }
    },
    '$store.state.mainFilterSearch.provID': function () {
      this.initialCardGroup();
    },
    '$store.state.mainFilterSearch.ampID': function () {
      this.initialCardGroup();
    },
    '$store.state.mainFilterSearch.tambolID': function () {
      this.initialCardGroup();
    },
    '$store.state.main.fragilePicked': function () {
      this.initialCardGroup();
    },
    '$store.state.main.probPicked': function () {
      this.initialCardGroup();
    },
    '$store.state.mainFilterSearch.osm': function () {
      this.initialCardGroup();
    }
  },
});
</script>
<style lang="scss" scoped>
.box-shadow {
  box-shadow: 0px 3px 6px rgb(0 0 0 / 16%);
}

input[type="radio"] {
  display: none;
}

#target_group_section div::-webkit-scrollbar {
  padding-top: 10px;
  margin-bottom: -10px !important;
  height: 5px;
}

#target_group_section div::-webkit-scrollbar-track {
  background: none;
}

#target_group_section div::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, .2);
  border-radius: 10px;
  transition: all .2s ease;
}

#target_group_section div::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, .4);
}

.nav-active {
  color: var(--blue-text-color);
  font-weight: bold;
  border-color: var(--blue-text-color);
}

.target-group-box {
  min-width: 275px;
  width: auto;
}

@media screen and (max-width: 991.8px) {
  .target-group-box {
    min-width: 270px;
    width: auto;
  }
}
</style>



